<script>
import PasswordReset from "./uporabnik/PassReset.vue"
import { i18n } from '@/i18n'
import sl from '@/Prevodi/Main-sl.json';
import en from '@/Prevodi/Main-en.json';
import it from '@/Prevodi/Main-it.json';
import { config } from '@/config'
// import PatchNotes from "./PatchNotes.vue";
export default {
  components: {
    PasswordReset,
    // PatchNotes,
  },
  emits: ['motorna',
    'jadralna',
    'ultralight',
    'obracun',
    'letala',
    'piloti',
    'klubi',
    'register',
    'odjava',
    'meniji',
    'nastavitve',
    'pregleddostopov',
    'ceniki',
    'pregledlogov',
    'pregledpovrsin',
    'dnevnikpilotov',
    'dnevnikpilotovJ',
    'ajdovscina',
    'potrdinalog',
    'pravice',
    'dnevnirazpored',
    'dodajpatchnotes',
    'pregledpovrsin',
    'nastavitveIzpisov',
    'porocila',
    'dodajPodpis',
    'deaktivirani',
    'razpolozljivost'
  ],
  data() {
    return {
      prevodi: false,
      NoData: '',
      meniji: [],
      menijiUporabnika: [],
      pokaziModal: false,
      PatchNotes: false,
      User: config.User,
      FullUser: config.FullUser,
      UserLVL: config.UserLVL,
      UserID:config.UserID,
      PwrUser: config.PwrUser,
      modules: {
        login: {
          "title": "Login",
          "url": "Login"
        },
        main: {
          "title": "Glavni meni",
          "url": "Main"
        },
        jadralna: {
          "title": "Startna lista (Jadralni)",
          "url": "letenje/Jadralna"
        },
        motorna: {
          "title": "Startna lista (Motorni)",
          "url": "letenje/Motorna"
        },
        ultralight: {
          "title": "Startna lista (Ultralight)",
          "url": "letenje/Ultralight"
        },
        obracun: {
          "title": "Obracun",
          "url": "obracuni/Obracun"
        },
        letala: {
          "title": "Sifrant letal",
          "url": "sifranti/Letala"
        },
        piloti: {
          "title": "Sifrant pilotov",
          "url": "sifranti/Piloti"
        },
        klubi: {
          "title": "Sifrant klubov",
          "url": "sifranti/Klubi"
        },
        Register: {
          "title": "Register",
          "url": "uporabnik/Register"
        },
        meniji: {
          "title": "Administracija",
          "url": "Nastavitve/Nastavitve"
        },
        nastavitve: {
          "title": "NastavitveSplosno",
          "url": "Nastavitve/Meni/Meni_splosno"
        },
        pregleddostopov: {
          "title": "PregledDostopov",
          "url": "urednik/Pregled_dostopov"
        },
        pregledlogov: {
          "title": "PregledLogov",
          "url": "logi/Log"
        },
        Ceniki: {
          "title": "Ceniki",
          "url": "Ceniki.js"
        },
        dnevnikpilotov: {
          "title": "Dnevnik pilotov (motorni)",
          "url": "dnevniki/DnevnikPilotov"
        },
        dnevnikpilotovJ: {
          "title": "Dnevnik pilotov (jadralni)",
          "url": "dnevniki/DnevnikJadralnihPilotov"
        },
        ajdovscina: {
          "title": "nalogi za let",
          "url": "Nalogi/Ajdovscina"
        },
        potrdinalog: {
          "title": "PotrdiNalog",
          "url": "Nalogi/potrdiNalog"
        },
        pravice: {
          "title": "pravice uporabnikov",
          "url": "pravice/Pravice"
        },
        dnevnirazpored: {
          "title": "Dnevni razored",
          "url": "razpored/DnevniRazpored"
        },
        dodajpatchnotes: {
          "title": "Spremembe programa",
          "url": "urednik/Changelog"
        },
        pregledpovrsin: {
          "title": "Pregled površin",
          "url": "povrsine/PregledPovrsin"
        },
        nastavitveIzpisov: {
          "title": "Nastavitve izpisov",
          "url": "nastavitve/Izpisi/Nastavitve_izpisi"
        },
        porocila: {
          "title": "Porocila",
          "url": "porocila/Porocila"
        },
        deaktivirani: {
          "title": "Deaktivirani uporabniki",
          "url": "pravice/DeaktiviraniUporabniki"
        },
        razpolozljivost: {
          "title": "Razpolozljivost",
          "url": "razpolozljivost/Razpolozljivost"
        },
        camoVzdrzevanje: {
          "title": "Camo pregled",
          "url": "pregledi/Camo"
        },
        camoLog: {
          "title": "Camo log",
          "url": "logi/CamoLog"
        },
        upravitelj: {
          "title": "Upravitelj",
          "url": "Nastavitve/upravitelj/nastavitve"
        },
        weightbalance: {
          "title": "Weight&Balance",
          "url": "briefing/WeightBalance"
        }
      },
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  beforeMount() {
    // setTimeout(() => {
    this.ReadUserMenu();
    // }, 100);
    this.ReadMenu();
  },
  mounted() {
    this.ReadMenu();
    this.CheckLogin();
    this.getLanguage();
    // this.ReadUserMenu();
    // setTimeout(() => {
    //     this.ReadUserMenu();
    // }, 100);
    setInterval(() => {
      this.CheckLogin();
    }, 600000);
  },
  computed: {
    vidniMeniji() {
      return this.meniji.filter(meni =>
          this.menijiUporabnika.includes(meni.id)
      );
    },
    menuSections() {

      const sections = [
        {
          title: 'hr.splosno',
          condition: true,
          menus: [18, 19, 1, 2, 3, 10, 11, 16, 22, 23, 25]
        },
        {
          title: 'hr.briefing',
          condition: true,
          menus: [28]
        },
        {
          title: 'hr.dokumenti',
          condition: true,
          menus: [13, 14]
        },
        {
          title: 'hr.dnevniki',
          condition: true,
          menus: [12, 21]
        },
        {
          title: 'hr.sifranti',
          condition: true,
          menus: [4, 5, 6]
        },
        {
          title: 'hr.nastavitveLeta',
          condition: true,
          menus: [8, 24]
        },
        {
          title: 'hr.pravice',
          condition: this.UserLVL < 2,
          menus: [15, 20]
        },
        {
          title: 'hr.upravitelj',
          condition: this.UserLVL < 2,
          menus: [27, 26]
        },
        {
          title: 'hr.administracija',
          condition: this.PwrUser,
          menus: [7, 9, 17, 26]
        }
      ];

      const userMenus = new Set(this.menijiUporabnika);

      return sections
          .map(section => ({
            ...section,
            items: this.meniji.filter(m =>
                section.menus.includes(m.id) &&
                userMenus.has(m.id)
            )
          }))
          .filter(section =>
              section.condition &&
              section.items.length > 0
          );
    }
  },
  methods: {
    ReadMenu() {
      axios.get('./api/nastavitve/meni/izpis').then((response) => {
        this.meniji = response.data.meniji;
      }).catch((error) => {
        this.text = `Prišlo je do napake pri nalaganju vsebine. Poskusite osvežiti stran. Če se napaka pojavlja obvestite upravitelja letališča.`;
        this.types = 'Napaka';
        this.ShowNoti = true;
        if (error.response.status === 401) {
          this.$router.push('/Logout');
        }
      });
    },
    ReadUserMenu() {
      var podatki = new URLSearchParams();
      podatki.append('uporabnik', this.UserID);
      axios.post('./api/nastavitve/meni/povezava/beri/', podatki, {withCredentials: true}).then((response) => {
        this.menijiUporabnika = response.data.meniji.map(meni => meni.id);
      }).catch((error) => {
        if (error.response.status === 401) {
          this.$router.push('/Logout');
        }
      });
    },
    CheckLogin() {
      axios.get('./api/prijava/', {withCredentials: true}).then((response) => {
        // console.log('ok prijava');
      }).catch((error) => {
        if (error.response.status === 401) {
          this.$router.push('/Logout');
        }
      })
    },
    ResetPassForm() {
      this.pokaziModal = !this.pokaziModal;
    },
    DetailsOff() {
      this.pokaziModal = false;
    },
    OpenPatchNotes() {
      this.PatchNotes = !this.PatchNotes;
    },
    PatchNotesOff() {
      this.PatchNotes = false;
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
    getLanguage() {
      axios.get('./api/nastavitve/jezik/', {withCredentials: true}).then((response) => {
        this.changeLang(response.data.jezik);
      }).catch((napaka) => {
        this.text = "Napaka pri pridobivanju jezika uporabnika!";
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    handleSignature(data) {
      this.$emit('dodajPodpis', data);
    },
    nazivLVL(lvl) {
      switch (lvl) { //switch case glede na poslane pravice
        case 0:
          return 'Admin'
        case 1:
          return 'Upravitelj';
        case 2:
          return 'Inštruktor';
        case 3:
          return 'Kronometrist';
        case 4:
          return 'Pilot';
        case 6:
          return 'Camo';
        default:
          return 'Gost';
      }
    },
    GoToModule(modul) {
      const info = this.modules[modul];
      this.$router.push(info.url);
      // window.umami.track(props => ({
      //     ...props,
      //     url: info.url,
      //     title: info.title
      // }));
    },

  }
}
</script>
<template>
  <div class="main-container" v-if="prevodi">
    <!-- Header Section -->
    <header class="main-header">
      <div class="header-content">
        <!-- User Info & Logout -->
        <div class="header-section header-left">
          <div class="user-info" @click.prevent="$emit('odjava')">
            <span class="user-name">{{(this.User) ? this.User.split('@')[0] : 'Ghost'}} <span class='user-lvl'>[{{this.nazivLVL(this.UserLVL)}}]</span></span>
            <div class="logout-btn">
              <i class="fas fa-sign-out-alt"></i>
              <span class="logout-text">{{$t('uporabnik.odjava')}}</span>
            </div>
          </div>
        </div>

        <!-- Center Title -->
        <div class="header-section header-center">
          <!-- <h1 class="main-title">{{$t('meni.title')}}</h1> -->
          <img src="/img/WingSI_simbol.png" class="logo-main-menu"  alt="logotip"/>
        </div>

        <!-- Action Buttons -->
        <div class="header-section header-right">
<!--          <button class="header-btn" @click.prevent="OpenPatchNotes()" title="Patch Notes">
            <i class="fas fa-info"></i>
          </button>-->
          <button class="header-btn" @click.prevent="ResetPassForm()" title="Nastavitve uporabnika" data-umami-event="Uporabnik-Nastavitve">
            <i class="fas fa-user-cog"></i>
            <span class='znacka-jezik'>{{$i18n.locale.toUpperCase()}}</span>
          </button>
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <main class="main-content">
      <!-- Warning Message -->
      <div class="warning-message" v-if="!menijiUporabnika.length > 0 && menijiUporabnika.length !== meniji.length">
        <i class="fas fa-exclamation-triangle"></i>
        <span>Nimate še dodeljenih pravic. Obrnite se na skrbnika ali vodjo letališča.</span>
      </div>

      <!-- Main Menu Section -->
      <div class="menu-section">
        <!-- POSAMEZNE SEKCIJE -->
        <div
            v-for="section in menuSections"
            :key="section.title"
            :class="{'menu-section': section.title !== 'hr.splosno', 'menu-grid': section.title === 'hr.splosno'}"
        >
          <div class="section-divider" v-if="section.title !== 'hr.splosno'">
            <span>{{ $t(section.title) }}</span>
          </div>
          <!-- MENIJI V SEKCIJI -->
          <div class="menu-grid" v-if="section.title !== 'hr.splosno'">
            <div
                v-for="meni in section.items"
                :key="meni.id"
                class="menu-card"
                @click="GoToModule(meni.pot)"
            >
              <div class="menu-icon">
                <i :class="meni.ikona"></i>
              </div>

              <div class="menu-content">
                <h3 class="menu-title">{{ $t(meni.t_naziv) }}</h3>
                <p class="menu-description">{{ $t(meni.t_opis) }}</p>
              </div>
            </div>
          </div>
          <!-- MENIJI V PRVI SEKCIJI (SPLOŠNO) -->
          <div
              v-for="meni in section.items"
              :key="meni.id"
              class="menu-card"
              @click="GoToModule(meni.pot)"
              v-else
          >
            <div class="menu-icon">
              <i :class="meni.ikona"></i>
            </div>

            <div class="menu-content">
              <h3 class="menu-title">{{ $t(meni.t_naziv) }}</h3>
              <p class="menu-description">{{ $t(meni.t_opis) }}</p>
            </div>
          </div>
        </div>
      </div>
    </main>
    <!-- PASS RESET KOMPONENTA -->
    <password-reset @zapri="DetailsOff()" :pokaziModal="pokaziModal" :UserID :FullUser @odjava="$emit('odjava')" @dodajPodpis="handleSignature" />
<!--    <patch-notes @zapri="PatchNotesOff()" :pokaziModal="PatchNotes" :UserID :FullUser />-->
  </div>

  <!--<i class="fas fa-plane"></i>  <i class="fas fa-clipboard-list"></i>-->
</template>